<template>
    <v-app id="app">

        <v-snackbar id="snackbar"
                    v-model="snackbar"
                    :bottom="y === 'bottom'"
                    :color='snackbarColor'
                    :timeout="timeout"
                    :top="y === 'top'">
            <v-icon style="color: white; padding-right: 2vw">{{snackbarIcon}}</v-icon> {{snackbarText}}
            <v-btn
                    color="white"
                    text
                    @click="snackbar = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>

        <v-slide-x-transition>
            <v-card id="login-area" style="height: 100%; width: 100%;" flat v-if="loaddd">

                <v-chip
                        x-small
                        color="#FFFFFF"
                        label
                        style="position: absolute; right: 0; bottom: 0;"
                >v1.2.0.5</v-chip>

                <div style="width: 100%; height: 30%; display: flex; justify-content: center; align-items: center">
                    <v-avatar
                            tile
                            :size="200"
                            width="285px"
                    >
                        <img :src="logoAPN">
                    </v-avatar>
                </div>

                    <div style="width: 100%; height: 15%;  padding-top: 2%; padding-left: 25%; padding-right: 25%;">
                        <v-text-field
                                v-model="login.username"
                                label="Username"
                                prepend-icon="fas fa-user"
                                color="#2e2e2e">
                        </v-text-field>
                    </div>

                <div style="width: 100%; height: 15%;  padding-top: 2%; padding-left: 25%; padding-right: 25%;">
                    <v-text-field
                            v-model="login.password"
                            color="#2e2e2e"
                            label="Password"
                            prepend-icon="fas fa-unlock-alt"
                            @keyup.enter="loginUser()"
                            :append-icon="passwordShow ? 'visibility' : 'visibility_off'"
                            :type="passwordShow ? 'text' : 'password'"
                            @click:append="passwordShow = !passwordShow"
                    ></v-text-field>
                </div>


                        <div style="width: 100%; height: 30%; display: flex; justify-content: center; align-items: center">
                            <v-btn style="color: white;" light  :loading="loadingButton" @click="loginUser" rounded min-height="48px" min-width="125px" color="#2e2e2e">Login</v-btn>
                        </div>

<!--                    </div>-->

                <div style="height: 10%"></div>
                </v-card>
        </v-slide-x-transition>

    </v-app>
</template>

<script>
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { AXIOS } from '../../http-common'

import VueRecaptcha from 'vue-recaptcha'

Vue.use(Vuetify)

export default {

  components: { VueRecaptcha },

  data () {
    return {
      disableLoginButton: true,
      redirectLoader: true,
      loaddd: false,
      logoAPN: require('../../images/logos/APNLogo.png'),
      loadingButton: false,
      amIinLogin: '',
      // notification/ wrong credentials Start
      snackbar: false,
      y: 'top',
      timeout: 5000,
      snackbarText: '', // Notification text
      snackbarColor: '', // Notification color
      snackbarIcon: '', // Notification icon
      // notification/ wrong credentials End
      passwordShow: false, // On default dont display password in string format
      token: '', // Variable to store and define the bearer token
      dashboardUrl: location.origin + '/topup/dashboard', // url to dashboard
      // login data Start
      login: {
        url: location.origin + '/topup/login', // login url
        username: '',
        password: ''
      }// login data End
    }
  },
  methods: {

    // Login for the user
    loginUser () {
      // Passes the information as parameters
      const params = new URLSearchParams()
      params.append('username', this.login.username)
      params.append('password', this.login.password)
      AXIOS({
        method: 'post',
        url: this.login.url,
        params
      })
        .then(response => {
          this.loadingButton = true
          this.token = response.headers.authorization.substr(7) // Gets response applies bearer token, removes the text 'Bearer'
          $cookies.set('session', this.token, '8h') // Sets the token for 8 hours
          setTimeout(() => location.replace(this.dashboardUrl), 1000) // Redirects user
        },
        (err) => {
          // If wrong details display message to the user
          if (err.response.status == 401 || err.response.status == 403) {
            this.snackbarText = 'The Username or Password are incorrect'
            this.snackbarColor = 'red'
            this.snackbarIcon = 'fas fa-exclamation-triangle'
            this.snackbar = true
          }
          // If cant connect display message to the user
          else if (err.response.status == 500) {
            this.snackbarText = 'Server seems to be down, contact support team'
            this.snackbarColor = 'orange'
            this.snackbarIcon = 'fas fa-exclamation-triangle'
            this.snackbar = true
          }
        }
        )
    }
  },
  created: function () {
    document.write('<meta name="viewport" content="width=device-width,height=' + window.innerHeight + ', initial-scale=1.0">')

    // On load if token exists redirect user to the dashboard page
    if (window.$cookies.get('session')) {
      location.replace(this.dashboardUrl)
      this.redirectLoader = true
    } else {
      this.redirectLoader = false
    }
    setTimeout(() => this.loaddd = true, 500)
  }
}
</script>

<style scoped>
    html, body {
        height: 100%;
        margin: 0;
    }
    /*#app {*/
        /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
        /*text-align: center;*/
        /*color: black;*/
        /*margin: 0;*/
        /*width: 100%;*/
        /*height: 100%;*/
        /*background-color: white;*/
    /*}*/

    @media screen and (min-width: 400px) {
        #app {
            font-family: 'Avenir', Helvetica, Arial, sans-serif;
            text-align: center;
            color: black;
            margin: 0;
            width: 100%;
            height: 100%;
        }

        #login-area {
            background-color: white;
        }

    }

    @media screen and (min-width: 800px) {
        #app {
            font-family: 'Avenir', Helvetica, Arial, sans-serif;
            text-align: center;
            color: black;
            margin: 0;
            width: 100%;
            height: 100%;
        }

        #login-area {
            background-color: white;
        }

    }
</style>
